/*
 * @Author: zxf
 * @Date: 2021-12-08 14:59:16
 * @LastEditors: zxf
 * @LastEditTime: 2022-10-24 15:48:28
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\source\SourceController.js
 */
import Singleton from '../clazz/Singleton';

/**
 * 数据源控制管理类
 * 用于管理所有的数据源,解析数据源配置文件,请求服务数据等
 */
export default class SourceController {
    /**
     * 初始化数据源管理类.
     * @returns {undefined}
     */
    constructor() {
        /**
         * 数据源容器
         * @type {Object} _sources
         */
        this._sources = {};
    }

    /**
     * 增加数据源方法
     * @param {Object} source - 数据源对象
     * @return {undefined}
     */
    add(source) {
        this._sources[source.name] = source;
    }

    /**
     * 根据数据源的名称删除数据源.
     * @param {String} sourceName - 数据源对象
     * @returns {undefined}
     */
    del(sourceName) {
        if (this._sources.hasOwnProperty(sourceName)) {
            delete this._sources[sourceName];
        }
    }

    /**
     * 清除所有数据源中的数据.
     * @returns {undefined}
     */
    clear() {
        const keys = Object.keys(this._sources);
        for (let i = 0; i < keys.length; ++i) {
            const key = keys[i];
            this._sources[key].clear();
        }
    }

    clearSourceByType(sourceName) {
        if (this._sources.hasOwnProperty(sourceName)) {
            this._sources[sourceName] = [];
        }
    }

    /**
     * 根据数据源名称获取数据源.
     * @param {String} sourceName - 数据源名称
     * @returns {Object} - 返回已sourceName为键值的数据源
     */
    getSource(sourceName) {
        if (!this._sources.hasOwnProperty(sourceName)) {
            return null;
        }

        return this._sources[sourceName];
    }

    /**
     * 获取所有数据源
     * @returns {Object[]} sources
     */
    getAllSources() {
        return Object.values(this._sources);
    }

    /**
     * 请求当前瓦片的数据源方法.
     * method requestTileData
     * @param {Object} tile - 当前要请求加载的瓦片
     * @param {Array} urls - 根据请求的所有数据类型组成的请求url对象
     * 数据结构为以数据源名称为键，以该类型数据源中所有要素数据类型组成的数组为值的hash表.
     * @returns {Promise} - Promise对象代表该瓦片下所有类型数据源(基于当前场景的配置)的请求.
     */
    requestData(urls) {
        const request = this._createRequests(tile, urls);
        const sources = request.sources;
    }

    /**
     * 创建单个数据源请求的Promise实例.
     * @param {Object} tile - 瓦片信息
     * @param {String} url - 数据源请求url
     * @param {object} options - 请求控制参数
     * @returns {promise} promise - 返回单个数据源数据异步请求实例
     */
     _createAjaxPromise(tile, url, options) {
        const request = ajax.$get(url, null, options);
        this.tileRequestController.add(tile.fullName, request.xhr);

        return request.promise;
    }

    /**
     * 将数据存入数据源中.
     * @param {Object} source - 数据源对象
     * @param {Object} features - 渲染数据对象
     * @param {Object} tile - 瓦片信息
     * @return {undefined}
     */
    _addFeaturesToDataSource(source, features, tile) {
        for (let i = 0; i < features.length; ++i) {
            const feature = features[i];
            source.add(feature, tile);
        }
    }
}
